import i18n from 'i18next';
import Xhr from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

export const langCodes = ['en-US','es','lt','de','nl','fr','pl','pt','ru','sv','ja', 'it', 'uk', 'hu'];

export const languageOptions = [
  {label: 'English', key: 'en-US'},
  {label: 'Español', key: 'es'},
  {label: 'Lietuvių', key: 'lt'},
  {label: 'Deutsch', key: 'de'},
  {label: 'Nederlands', key: 'nl'},
  {label: 'Portugues', key: 'pt'},
  {label: 'Français', key: 'fr'},
  {label: 'Pусский', key: 'ru'},
  {label: 'Polskie', key: 'pl'},
  {label: 'Svenska', key: 'sv'},
  {label: '日本人', key: 'ja'},
  {label: 'Italiano', key: 'it'},
  {label: 'Українська', key: 'uk'},
  {label: 'Magyar', key: 'hu'}
];

export const matchWithSupportedLangs = () => {
  if (langCodes.includes(i18n.language)) {
    return i18n.language;
  }
  try {
    const l = i18n.language.slice(0,2).toLowerCase();
    if (langCodes.includes(l)) {
      return l;
    }
    return 'en-US';
  }
  catch(err) {
    return 'en-US';
  }
};

i18n
  .use(LanguageDetector)
  .use(Xhr)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en-US',
    // debug: isDev(),
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false
    }
  });

export default i18n;
